<template>
<BootstrapDialog title="试卷克隆" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-8 col-sm-offset-2">
		            <form role="form" class="form-horizontal">
		                <div class="form-group">
		                    <label class="col-sm-3 control-label"><span class="required" >*</span>新试卷名称</label>
		                    <div class="col-sm-9">
		                        <input type="text" v-model="model.sjmc" name="xsjmc" placeholder="" v-validate="{required:true,max:50}"  class="form-control" data-vv-as="新试卷名称"  >
		                        <span class="error_validate_msg"><em>{{ errors.first('xsjmc') }}</em></span>
		                    </div>
		                </div>
		                <div class="form-group">
		                    <label class="col-sm-3 control-label"><span class="required" >*</span>报考专业</label>
		                    <div class="col-sm-9">
		                        <select name="pcId" v-model="model.xmId" class="form-control" v-validate="{required:true}" data-vv-as="报考专业">
		                            <option value="">-请选择-</option>
		                            <option v-for="item in pcList" :key="item.id" :value="item.id">{{item.mc}}</option>
		                        </select>
		                        <span class="error_validate_msg"><em>{{ errors.first('pcId') }}</em></span>
		                    </div>
		                </div>
		                <!--课程-->
		                <div class="form-group">
		                    <label class="col-sm-3 control-label"><span class="required">*</span>课程</label>
		                    <div class="col-sm-9">
		                        <select name="kc" v-model="model.kcId" class="form-control"
		                                v-validate="{required:true,max:50}" data-vv-as="课程">
		                            <option value="">-请选择-</option>
		                            <option v-for="kc in kcList" :key="kc.id" :value="kc.id">{{kc.kcmc}}
		                            </option>
		                        </select>
		                        <span class="error_validate_msg"><em>{{ errors.first('kc') }}</em></span>
		                    </div>
		                </div>
		                <div class="form-group">
		                    <label class="col-sm-3 control-label"><span class="required" >*</span>开始时间</label>
		                    <div class="col-sm-9">
								<DateTimePicker v-model="model.kksj" name="kssj" v-validate="{required:true}" data-vv-as="开始时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
		                        <div>
		                            <span class="error_validate_msg" ><em>{{ errors.first('kssj') }}</em></span>
		                        </div>
		                    </div>
		                </div>
		                <div class="form-group">
		                    <label class="col-sm-3 control-label"><span class="required" >*</span>结束时间</label>
		                    <div class="col-sm-9">
								<DateTimePicker v-model="model.jssj" name="jssj" v-validate="{required:true}" data-vv-as="结束时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
		                        <div>
		                            <span class="error_validate_msg" ><em>{{ errors.first('jssj') }}</em></span>
		                        </div>
		                    </div>
		                </div>
		            </form>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
		<button class="btn btn-primary" type="button" @click="save()">保存</button>
		<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     *  综合测验 克隆试卷
     */
    export default {
        name:'ExamPaperClone',
        components:{
        },
        data:function(){
            return {
                pcList:[],
                kcList: [],
                model:{
                    id:'',
                    xmId:'',
                    kcId: '',
                    sjmc:'',
                    kssj:'',
                    jssj:''
                }
            }
        },
        watch: {  //课程列表联动
            "model.xmId": function (value) {
				this.model.kcId = '';
                if (value) {
                    this.$http.post("/htgl/biz/zypx/sj/pszy/hqkc", {pcId: value}).then(res => {
                        this.kcList = res.data;
                    });
                }
                else {
                    this.kcList = [];
                }
            }
        },
        methods:{
			reset:function(){
				this.pcList = [];
				this.kcList = [];
				this.model = {
					id:'',
					xmId:'',
					kcId: '',
					sjmc:'',
					kssj:'',
					jssj:''
				}
			},
			async open(params){
				this.model.id = params.id;
				let res =await this.$http.post('/htgl/biz/zypx/sj/zhcy/hqpc');
				if(res.data){
					this.pcList = res.data;
				}
				res =await this.$http.post('/htgl/biz/zypx/sj/zhcy/hq',{id:this.model.id});
				if(res.data){
					this.model = res.data || {};
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.model.pcId=this.model.xmId;
                        this.$http.post('/htgl/biz/zypx/sj/zhcy/klsj',this.model).then(res=>{
                            if(res.data==true){
                                this.$success("操作成功",()=>{
									this.close();
                                    this.$parent.load();//刷新列表
                                });
                            }
                        })
                    }
                });
            }
        }
    }
</script>
